{
  "version": "1.2.6",
  "objects": {
    "7452339092592568507": {
      "type": "frame",
      "id": "7452339092592568507",
      "z": -50,
      "textContent": "",
      "left": 57.63684082558507,
      "top": -251.93007668951498,
      "width": 400,
      "height": 500,
      "scaleX": 1.183010251480685,
      "scaleY": 1.1790755027656687,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 0,
      "layoutPadding": 10,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7452339627382216239": {
      "type": "frame",
      "id": "7452339627382216239",
      "z": -60,
      "textContent": "Frame 63",
      "left": 67.63684082558507,
      "top": -241.93007668951498,
      "width": 400,
      "height": 500,
      "scaleX": 1.133010251480685,
      "scaleY": 0.18603236185978222,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7452339092592568507",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452338472571428079": {
      "type": "shape",
      "id": "7452338472571428079",
      "z": 9190,
      "shapeName": "text",
      "textContent": "<p>Title</p>",
      "left": 87.63684082558507,
      "top": -220.92198622456942,
      "width": 50.16666666666667,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.7142857142857142,
      "scaleY": 1.7142857142857142,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 24,
      "angle": 0,
      "container": "7452339627382216239",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a0",
      "wrapText": true,
      "maskType": "none",
      "locked": false
    },
    "7452338472562263474": {
      "type": "shape",
      "id": "7452338472562263474",
      "z": 9191,
      "shapeName": "icon",
      "textContent": "",
      "left": 485.7141404035831,
      "top": -205.92342703599024,
      "width": 100,
      "height": 160,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.13126801014276016,
      "scaleY": 0.13126801014276016,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 0.3,
      "borderOpacity": 1,
      "fill": "#333333",
      "angle": 0,
      "container": "7452339627382216239",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "iconName": "fas/xmark",
      "locked": false
    },
    "7452340939812413769": {
      "type": "frame",
      "id": "7452340939812413769",
      "z": -60,
      "textContent": "Frame 63",
      "left": 67.63684082558507,
      "top": -148.91389575962387,
      "width": 400,
      "height": 500,
      "scaleX": 1.133010251480685,
      "scaleY": 0.34960403790572625,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7452339092592568507",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0V",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452340035363731864": {
      "type": "frame",
      "id": "7452340035363731864",
      "z": 143,
      "textContent": "Frame 64",
      "left": 397.84094141785914,
      "top": -129.61489573012594,
      "width": 400,
      "height": 500,
      "scaleX": 0.2575,
      "scaleY": 0.27240803778773454,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452340939812413769",
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 20,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7452340035359618224": {
      "type": "wireframe",
      "id": "7452340035359618224",
      "z": 286,
      "top": -109.61489573012594,
      "left": 423.7389319709255,
      "width": 150,
      "height": 150,
      "scaleX": 0.34136012595911513,
      "scaleY": 0.34136012595911513,
      "container": "7452340035363731864",
      "layoutPosition": "a0",
      "wireframeName": "placeholder",
      "fill": "#0073CF",
      "textColor": "#333333",
      "style": "placeholder",
      "fontSize": 14,
      "label": {},
      "placeholder": {}
    },
    "7452340035373073875": {
      "type": "shape",
      "id": "7452340035373073875",
      "z": 429,
      "shapeName": "text",
      "textContent": "<p>Messages</p>",
      "left": 417.84094141785914,
      "top": -38.410876836258666,
      "width": 73.5,
      "height": 29.166666666666668,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8571428571428571,
      "scaleY": 0.8571428571428571,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 12,
      "angle": 0,
      "container": "7452340035363731864",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7452341076706578702": {
      "type": "frame",
      "id": "7452341076706578702",
      "z": 146,
      "textContent": "Frame 64",
      "left": 294.4395745537678,
      "top": -129.61489573012594,
      "width": 400,
      "height": 500,
      "scaleX": 0.22801004723466817,
      "scaleY": 0.27240803778773454,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452340939812413769",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 20,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7452341076711016508": {
      "type": "wireframe",
      "id": "7452341076711016508",
      "z": 153,
      "top": -109.61489573012594,
      "left": 314.9395745537678,
      "width": 150,
      "height": 150,
      "scaleX": 0.34136012595911513,
      "scaleY": 0.34136012595911513,
      "container": "7452341076706578702",
      "layoutPosition": "a0",
      "wireframeName": "placeholder",
      "fill": "#0073CF",
      "textColor": "#333333",
      "style": "placeholder",
      "fontSize": 14,
      "label": {},
      "placeholder": {}
    },
    "7452341076705502263": {
      "type": "shape",
      "id": "7452341076705502263",
      "z": 154,
      "shapeName": "text",
      "textContent": "<p>Email</p>",
      "left": 321.0415840007014,
      "top": -38.410876836258666,
      "width": 45.5,
      "height": 29.166666666666668,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8571428571428571,
      "scaleY": 0.8571428571428571,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 12,
      "angle": 0,
      "container": "7452341076706578702",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7452341078654510429": {
      "type": "frame",
      "id": "7452341078654510429",
      "z": 147,
      "textContent": "Frame 64",
      "left": 191.0382076896764,
      "top": -129.61489573012594,
      "width": 400,
      "height": 500,
      "scaleX": 0.22801004723466817,
      "scaleY": 0.27240803778773454,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452340939812413769",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 20,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7452341078663136884": {
      "type": "wireframe",
      "id": "7452341078663136884",
      "z": 151,
      "top": -109.61489573012594,
      "left": 211.5382076896764,
      "width": 150,
      "height": 150,
      "scaleX": 0.34136012595911513,
      "scaleY": 0.34136012595911513,
      "container": "7452341078654510429",
      "layoutPosition": "a0",
      "wireframeName": "placeholder",
      "fill": "#0073CF",
      "textColor": "#333333",
      "style": "placeholder",
      "fontSize": 14,
      "label": {},
      "placeholder": {}
    },
    "7452341078662296282": {
      "type": "shape",
      "id": "7452341078662296282",
      "z": 152,
      "shapeName": "text",
      "textContent": "<p>Aha!</p>",
      "left": 220.64021713661003,
      "top": -38.410876836258666,
      "width": 38.5,
      "height": 29.166666666666668,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8571428571428571,
      "scaleY": 0.8571428571428571,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 12,
      "angle": 0,
      "container": "7452341078654510429",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7452341080773945572": {
      "type": "frame",
      "id": "7452341080773945572",
      "z": 148,
      "textContent": "Frame 64",
      "left": 87.63684082558507,
      "top": -129.61489573012594,
      "width": 400,
      "height": 500,
      "scaleX": 0.22801004723466817,
      "scaleY": 0.27240803778773454,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452340939812413769",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 20,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7452341080764417784": {
      "type": "wireframe",
      "id": "7452341080764417784",
      "z": 149,
      "top": -109.61489573012594,
      "left": 108.13684082558507,
      "width": 150,
      "height": 150,
      "scaleX": 0.34136012595911513,
      "scaleY": 0.34136012595911513,
      "container": "7452341080773945572",
      "layoutPosition": "a0",
      "wireframeName": "placeholder",
      "fill": "#0073CF",
      "textColor": "#333333",
      "style": "placeholder",
      "fontSize": 14,
      "label": {},
      "placeholder": {}
    },
    "7452341080776736061": {
      "type": "shape",
      "id": "7452341080776736061",
      "z": 150,
      "shapeName": "text",
      "textContent": "<p>Other</p>",
      "left": 114.2388502725187,
      "top": -38.410876836258666,
      "width": 45.5,
      "height": 29.166666666666668,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8571428571428571,
      "scaleY": 0.8571428571428571,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 12,
      "angle": 0,
      "container": "7452341080773945572",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7452338915335773495": {
      "type": "frame",
      "id": "7452338915335773495",
      "z": -40,
      "textContent": "Frame 57",
      "left": 67.63684082558507,
      "top": 25.888123193239267,
      "width": 400,
      "height": 500,
      "scaleX": 1.133010251480685,
      "scaleY": 0.6033391030001604,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452339092592568507",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0l",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 20,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7452338741186334457": {
      "type": "frame",
      "id": "7452338741186334457",
      "z": -30,
      "textContent": "Frame 54",
      "left": 87.63684082558504,
      "top": 45.88812319323927,
      "width": 400,
      "height": 500,
      "scaleX": 1.0330102514806851,
      "scaleY": 0.10083477575004009,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452338915335773495",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452338623046448341": {
      "type": "frame",
      "id": "7452338623046448341",
      "z": -20,
      "textContent": "Frame 53",
      "left": 87.63684082558504,
      "top": 45.88812319323927,
      "width": 400,
      "height": 500,
      "scaleX": 0.2735434696875501,
      "scaleY": 0.10083477575004009,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452338741186334457",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 5,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452338472561949256": {
      "type": "wireframe",
      "id": "7452338472561949256",
      "z": 9166,
      "top": 46.38812319323927,
      "left": 87.63684082558504,
      "width": 52,
      "height": 52,
      "scaleX": 0.9695651514426931,
      "scaleY": 0.9695651514426931,
      "container": "7452338623046448341",
      "layoutPosition": "a0",
      "wireframeName": "avatar",
      "fill": "#808080",
      "textColor": "#333333",
      "style": "round",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "value": "",
        "iconLeft": { "prefix": "fas", "iconName": "user" }
      },
      "showBackground": true,
      "showOutline": true
    },
    "7452338472571603955": {
      "type": "shape",
      "id": "7452338472571603955",
      "z": 9167,
      "shapeName": "text",
      "textContent": "<p>Name</p>",
      "left": 143.05422870060508,
      "top": 54.59681713074929,
      "width": 47.25,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.1428571428571428,
      "scaleY": 1.1428571428571428,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 16,
      "angle": 0,
      "container": "7452338623046448341",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7452338472576111354": {
      "type": "wireframe",
      "id": "7452338472576111354",
      "z": 9168,
      "top": 50.921627736809896,
      "left": 443.26518534486104,
      "width": 56.57575607299805,
      "height": 40.35037878787879,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7452338741186334457",
      "layoutPosition": "a1",
      "wireframeName": "button",
      "fill": "#0073CF",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Send" }
    },
    "7452338895906100263": {
      "type": "frame",
      "id": "7452338895906100263",
      "z": 572,
      "textContent": "Frame 54",
      "left": 87.63684082558504,
      "top": 116.3055110682593,
      "width": 400,
      "height": 500,
      "scaleX": 1.0330102514806851,
      "scaleY": 0.10083477575004009,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452338915335773495",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452338895914629413": {
      "type": "frame",
      "id": "7452338895914629413",
      "z": 1144,
      "textContent": "Frame 53",
      "left": 87.63684082558504,
      "top": 116.3055110682593,
      "width": 400,
      "height": 500,
      "scaleX": 0.2735434696875501,
      "scaleY": 0.10083477575004009,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452338895906100263",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 5,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452338895909673477": {
      "type": "wireframe",
      "id": "7452338895909673477",
      "z": 1716,
      "top": 116.8055110682593,
      "left": 87.63684082558504,
      "width": 52,
      "height": 52,
      "scaleX": 0.9695651514426931,
      "scaleY": 0.9695651514426931,
      "container": "7452338895914629413",
      "layoutPosition": "a0",
      "wireframeName": "avatar",
      "fill": "#808080",
      "textColor": "#333333",
      "style": "round",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "value": "",
        "iconLeft": { "prefix": "fas", "iconName": "user" }
      },
      "showBackground": true,
      "showOutline": true
    },
    "7452338895911730746": {
      "type": "shape",
      "id": "7452338895911730746",
      "z": 2288,
      "shapeName": "text",
      "textContent": "<p>Name</p>",
      "left": 143.05422870060508,
      "top": 125.01420500576933,
      "width": 47.25,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.1428571428571428,
      "scaleY": 1.1428571428571428,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 16,
      "angle": 0,
      "container": "7452338895914629413",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7452338895907411989": {
      "type": "wireframe",
      "id": "7452338895907411989",
      "z": 2860,
      "top": 121.33901561182994,
      "left": 443.26518534486104,
      "width": 56.57575607299805,
      "height": 40.35037878787879,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7452338895906100263",
      "layoutPosition": "a1",
      "wireframeName": "button",
      "fill": "#0073CF",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Send" }
    },
    "7452338962751458115": {
      "type": "frame",
      "id": "7452338962751458115",
      "z": 572,
      "textContent": "Frame 54",
      "left": 87.63684082558504,
      "top": 186.72289894327935,
      "width": 400,
      "height": 500,
      "scaleX": 1.0330102514806851,
      "scaleY": 0.10083477575004009,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452338915335773495",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a2",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452338962756145294": {
      "type": "frame",
      "id": "7452338962756145294",
      "z": 686,
      "textContent": "Frame 53",
      "left": 87.63684082558504,
      "top": 186.72289894327935,
      "width": 400,
      "height": 500,
      "scaleX": 0.2735434696875501,
      "scaleY": 0.10083477575004009,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452338962751458115",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 5,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452338962753048045": {
      "type": "wireframe",
      "id": "7452338962753048045",
      "z": 800,
      "top": 187.22289894327935,
      "left": 87.63684082558504,
      "width": 52,
      "height": 52,
      "scaleX": 0.9695651514426931,
      "scaleY": 0.9695651514426931,
      "container": "7452338962756145294",
      "layoutPosition": "a0",
      "wireframeName": "avatar",
      "fill": "#808080",
      "textColor": "#333333",
      "style": "round",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "value": "",
        "iconLeft": { "prefix": "fas", "iconName": "user" }
      },
      "showBackground": true,
      "showOutline": true
    },
    "7452338962754406285": {
      "type": "shape",
      "id": "7452338962754406285",
      "z": 914,
      "shapeName": "text",
      "textContent": "<p>Name</p>",
      "left": 143.05422870060508,
      "top": 195.43159288078937,
      "width": 47.25,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.1428571428571428,
      "scaleY": 1.1428571428571428,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 16,
      "angle": 0,
      "container": "7452338962756145294",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7452338962754283467": {
      "type": "wireframe",
      "id": "7452338962754283467",
      "z": 1028,
      "top": 191.75640348684996,
      "left": 443.26518534486104,
      "width": 56.57575607299805,
      "height": 40.35037878787879,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7452338962751458115",
      "layoutPosition": "a1",
      "wireframeName": "button",
      "fill": "#0073CF",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Send" }
    },
    "7452338964304410071": {
      "type": "frame",
      "id": "7452338964304410071",
      "z": 572,
      "textContent": "Frame 54",
      "left": 87.63684082558504,
      "top": 257.1402868182994,
      "width": 400,
      "height": 500,
      "scaleX": 1.0330102514806851,
      "scaleY": 0.10083477575004009,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452338915335773495",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a3",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452338964307345256": {
      "type": "frame",
      "id": "7452338964307345256",
      "z": 594,
      "textContent": "Frame 53",
      "left": 87.63684082558504,
      "top": 257.1402868182994,
      "width": 400,
      "height": 500,
      "scaleX": 0.2735434696875501,
      "scaleY": 0.10083477575004009,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452338964304410071",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 5,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452338964304432921": {
      "type": "wireframe",
      "id": "7452338964304432921",
      "z": 616,
      "top": 257.6402868182994,
      "left": 87.63684082558504,
      "width": 52,
      "height": 52,
      "scaleX": 0.9695651514426931,
      "scaleY": 0.9695651514426931,
      "container": "7452338964307345256",
      "layoutPosition": "a0",
      "wireframeName": "avatar",
      "fill": "#808080",
      "textColor": "#333333",
      "style": "round",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "value": "",
        "iconLeft": { "prefix": "fas", "iconName": "user" }
      },
      "showBackground": true,
      "showOutline": true
    },
    "7452338964308527214": {
      "type": "shape",
      "id": "7452338964308527214",
      "z": 638,
      "shapeName": "text",
      "textContent": "<p>Name</p>",
      "left": 143.05422870060508,
      "top": 265.8489807558094,
      "width": 47.25,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.1428571428571428,
      "scaleY": 1.1428571428571428,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 16,
      "angle": 0,
      "container": "7452338964307345256",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7452338964317741849": {
      "type": "wireframe",
      "id": "7452338964317741849",
      "z": 660,
      "top": 262.17379136187003,
      "left": 443.26518534486104,
      "width": 56.57575607299805,
      "height": 40.35037878787879,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7452338964304410071",
      "layoutPosition": "a1",
      "wireframeName": "button",
      "fill": "#0073CF",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Send" }
    },
    "7452338472568562493": {
      "type": "frame",
      "id": "7452338472568562493",
      "z": 9164,
      "textContent": "Frame 155",
      "left": 294.2188911217221,
      "top": 327.5576746933194,
      "width": 400,
      "height": 500,
      "scaleX": 0.0001,
      "scaleY": 0.0001,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7452339092592568507",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452338472570471873": {
      "type": "frame",
      "id": "7452338472570471873",
      "z": 9165,
      "textContent": "Frame 109",
      "left": 294.2188911217221,
      "top": 327.5576746933194,
      "width": 400,
      "height": 500,
      "scaleX": 0.0001,
      "scaleY": 0.0001,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452338472568562493",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 3,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    }
  }
}
